import { fromNow } from '@btime/helpers'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useOpenNonCompliances } from './_load/OpenNonCompliancesLoader'
import { useOpenNonComplianceModal } from '../../../../../utils/routes/modals/modalsActions'
import FlexGrid, { FlexCol } from '../../../../../components/structure/FlexGrid'
import IconButton from '../../../../../components/actions/IconButton'
import Panel from '../../../../../packages/kiti/components/structure/Panel'
import Separator from '../../../../../components/helpers/Separator'
import { SmallText, Text } from '../../../../../components/presentation/Text'

const OpenNonCompliancesList = () => {
  const { t } = useTranslation(['availability', 'common'])
  const items = useOpenNonCompliances()
  const openNonComplianceModal = useOpenNonComplianceModal()

  if (!items.length) {
    return <SmallText color="dark3">{t('openNonCompliancesList.empty')}</SmallText>
  }

  return (
    <FlexGrid direction="column" gutter={0.4} align="stretch">
      {items.map(item => (
        <Panel key={item.id} bgColor="light1" noMargin>
          <FlexGrid justify="space-between" align="center">
            <FlexCol flex={1}>
              <Text bold color="dark2">
                {item.question?.name}
              </Text>
              <SmallText color="dark3">
                {item.question?.checklist?.name} · {fromNow(item.insertedAt)}
              </SmallText>
            </FlexCol>

            <FlexCol>
              <IconButton
                iconLeft="BsSearch"
                label={t('common:seeDetails')}
                transparent
                onClick={() => openNonComplianceModal(item)}
              />
            </FlexCol>
          </FlexGrid>
        </Panel>
      ))}
      <Separator weight={1} />
    </FlexGrid>
  )
}

export default OpenNonCompliancesList
